export { getBestTrailQuestion, BestTrailAnswer } from './BestTrailFaq';
